import Nav from "./../Page/Share/Nav/Nav";
const Post4 = () => {
  return (
    <div>
      <div className="container">
        <Nav></Nav>

        <div className="infowork">
          {/* items Title} */}
          <h2>
            Annie Ricci Brand Guidelines
          </h2>
          {/* items?.Description */}
          <p>

          </p>
          {/* img section */}
          <img src="https://i.ibb.co/kMT94rL/Annie-Ricci-Guidelines-01.jpg" alt="" />
          <img src="https://i.ibb.co/YdDyJY9/Annie-Ricci-Guidelines-02.jpg" alt="" />
          <img src="https://i.ibb.co/xFwdQ4Y/Annie-Ricci-Guidelines-03.jpg" alt="" />
          <img src="https://i.ibb.co/pZPt41Y/Annie-Ricci-Guidelines-04.jpg" alt="" />
          <img src="https://i.ibb.co/rtskWvt/Annie-Ricci-Guidelines-05.jpg" alt="" />
          <img src="https://i.ibb.co/0BWpRnh/Annie-Ricci-Guidelines-06.jpg" alt="" />
          <img src="https://i.ibb.co/DLG649v/Annie-Ricci-Guidelines-07.jpg" alt="" />
          <img src="https://i.ibb.co/tY4dJHt/Annie-Ricci-Guidelines-08.jpg" alt="" />
          <img src="https://i.ibb.co/3sZwKK4/Annie-Ricci-Guidelines-09.jpg" alt="" />
          <img src="https://i.ibb.co/hB9t2pn/Annie-Ricci-Guidelines-10.jpg" alt="" />
          <img src="https://i.ibb.co/wCQW2r0/Annie-Ricci-Guidelines-11.jpg" alt="" />
          <img src="https://i.ibb.co/rfdptqN/Annie-Ricci-Guidelines-12.jpg" alt="" />
          <img src="https://i.ibb.co/1nx2wYc/Annie-Ricci-Guidelines-13.jpg" alt="" />
          <img src="https://i.ibb.co/W3Vc0kQ/Annie-Ricci-Guidelines-14.jpg" alt="" />
          <img src="https://i.ibb.co/hCB7xdL/Annie-Ricci-Guidelines-15.jpg" alt="" />
          <img src="https://i.ibb.co/cNmsDKY/Annie-Ricci-Guidelines-16.jpg" alt="" />
          <img src="https://i.ibb.co/Sc0t4GW/Annie-Ricci-Guidelines-17.jpg" alt="" />
          <p>

          </p>
        </div>
      </div>
    </div>
  );
};

export default Post4;
